<div class="card smaller configuration-panel-card k-mt-5">
  <div class="card-header">Designeinstellungen</div>
  <div class="card-body">
    <form class="k-form" [formGroup]="baseStylingForm()">
      <kendo-formfield orientation="horizontal">
        <kendo-label text="Theme-Farbe" [for]="themeColor"></kendo-label>
        <kendo-colorpicker
          [format]="'hex'"
          class="k-w-24"
          [formControlName]="formControlNames.ThemeColor"
          (valueChange)="formValueChanged([$event, formControlNames.ThemeColor])"
          [views]="['gradient']"
          #themeColor
        >
        </kendo-colorpicker>
      </kendo-formfield>

      <kendo-formfield orientation="horizontal">
        <kendo-label text="Footer Hintergrundfarbe" [for]="footerBackgroundColor"></kendo-label>
        <kendo-colorpicker
          [format]="'hex'"
          class="k-w-24"
          [formControlName]="formControlNames.FooterBackgroundColor"
          (valueChange)="formValueChanged([$event, formControlNames.FooterBackgroundColor])"
          [views]="['gradient']"
          #footerBackgroundColor
        />
      </kendo-formfield>
    </form>
  </div>
</div>
